module.exports = __webpack_public_path__ + "static/media/ic_table_feature_off.9d45b10e.svg";